export { useAPIPutPartner } from './put-partner.hook';
